// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLayout_wrapper__zfo5S","hideSidebar":"AppLayout_hideSidebar__H66ZJ"};